import React from 'react';
import SVG from 'react-inlinesvg';
import cx from 'classnames';

export const ActionButtonIcon = (icon: string): JSX.Element => <SVG src={icon} className="w-4 h-4" />;

export const ActionButtons: React.FC = ({ children }) => (
  <div data-test-id="planner-line-actions-buttons" className="flex items-center space-x-1">
    {children}
  </div>
);

export const LineName: React.FC<{ name?: string }> = ({ name }) => (
  <h1
    data-test-id="planner-line-actions-name"
    className={cx('w-48 whitespace-nowrap overflow-hidden text-ellipsis header-lg', {
      'italic text-essential-tertiary': !name,
    })}
  >
    {name || 'Unsaved deal line'}
  </h1>
);

export const LineId: React.FC<{ lineId?: string }> = ({ lineId }) => (
  <span
    data-test-id="planner-line-actions-id"
    className="sub-header-base text-neutral-950-opacity-90 text-ellipsis text-xs"
  >
    {lineId}
  </span>
);

export const LineActions: React.FC = ({ children }) => (
  <div data-test-id="planner-line-actions" className="flex justify-between items-center pb-1">
    {children}
  </div>
);
